// extracted by mini-css-extract-plugin
export default {"customBread":"Breadcrumb_customBread__DnNFs","previewBread":"Breadcrumb_previewBread__px89w","breadSection":"Breadcrumb_breadSection__3E8Mz"};